import React from "react";
import "./media.css";
import MediaBody from "./MediaBody";

export const Media = ({ children, className = null, style = {} }) => {
  return (
    <div style={style} className={className ? className + " media" : "media"}>
      {children}
    </div>
  );
};

Media.Body = MediaBody;
